import usePrivateAxios from "@/common/api/usePrivateAxios"
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant"
import { Mapper } from "@/common/services/mapper"
import { MetaResponse } from "@/common/types/metaResponse"
import { useQuery } from "@tanstack/react-query"

interface useEstablishmentProductssProps<T> {
  filters: {
    search?: string;
    page: number;
    productCategory?: string;
    companyBranch?: string;
  }
  mapper?: (data: any) => T,
  enabled?: boolean;
}

export const useEstablishmentProducts = <T,>({
  mapper = Mapper.default<T>(),
  filters: { search = "", page, productCategory, companyBranch },
  enabled = true
}: useEstablishmentProductssProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ["establishmentProducts", search, page, productCategory, companyBranch],
    queryFn: async () => {
      return await privateAxios.get("/establishment/product_prices", {
        params: {
          'q[product_category_id_eq]': productCategory,
          'q[branch_id_eq]': companyBranch,
          search,
          page
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    enabled
  })

  return {
    data,
    meta,
    isPending,
    ...rest
  };
};
